import React from "react";
import dayjs from "dayjs";
import "dayjs/locale/id";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Edit from "../action/Edit";
import Hapus from "../action/Hapus";

import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";

dayjs.locale("id");

function DataOutMaterial({ rows, handleDelete, handleEdit, loading = false }) {
  const materialTemplate = (row) => (
    <div>
      <p className="m-0 text-sm font-semibold text-gray-900">{row.nama_material || "-"}</p>
      <p className="m-0 text-xs text-gray-500">{row.satuan || ""}</p>
    </div>
  );

  const jumlahTemplate = (row) => `${row.jumlah_pakai ?? 0} ${row.satuan || ""}`.trim();

  const aksiTemplate = (row) => (
    <div className="flex items-center justify-center gap-2">
      <Edit id={row.id} handleEdit={handleEdit} />
      <Hapus id={row.id} handleDelete={handleDelete} />
    </div>
  );

  if (loading) {
    return (
      <div className="flex h-72 items-center justify-center">
        <div className="text-center">
          <div className="mx-auto mb-2 h-8 w-8 animate-spin rounded-full border-b-2 border-primary" />
          <p className="text-gray-600">Memuat material keluar...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full">
      <DataTable
        value={rows}
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 25, 50]}
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Menampilkan {first} sampai {last} dari {totalRecords} data"
        emptyMessage="Belum ada pemakaian material"
        stripedRows
        showGridlines
        responsiveLayout="scroll"
        className="p-datatable-sm"
      >
        <Column
          field="tgl_pakai"
          header="Tanggal"
          body={(row) => (row.tgl_pakai ? dayjs(row.tgl_pakai).format("DD MMM YYYY") : "-")}
          style={{ minWidth: "120px" }}
          sortable
        />
        <Column header="Material" body={materialTemplate} style={{ minWidth: "180px" }} />
        <Column header="Jumlah" body={jumlahTemplate} style={{ minWidth: "110px" }} />
        <Column field="lokasi_pakai" header="Lokasi" body={(row) => row.lokasi_pakai || "-"} style={{ minWidth: "140px" }} />
        <Column field="teknisi" header="Pengambil" body={(row) => row.teknisi || "-"} style={{ minWidth: "140px" }} />
        <Column field="keterangan" header="Keterangan" body={(row) => row.keterangan || "-"} style={{ minWidth: "160px" }} />
        <Column header="Aksi" body={aksiTemplate} style={{ minWidth: "100px", textAlign: "center" }} />
      </DataTable>
    </div>
  );
}

export default DataOutMaterial;
